module.exports = __webpack_public_path__ + "img/phone-cover-start.96148754.png";